import ky from 'ky-universal';

const apiUrl = process.env.INTERNAL_API_URL;

const serverRequest = token => {
    return ky.extend({
        prefixUrl: apiUrl,
        hooks: {
            beforeRequest: [
                r => {
                    r.headers.set('Authorization', `Bearer ${token}`);
                    r.headers.set('Content-type', 'application/json');
                },
            ],
        },
        timeout: process.env.HTTP_TIMEOUT,
    });
};

export default serverRequest;
